import styled from "@emotion/styled";
import React, { forwardRef } from "react";
import { PolymorphicComponentProps } from "../types";
interface TextOwnProps {
  type: "baseline" | "body01" | "body02";
}

type TextProps<T extends React.ElementType> = PolymorphicComponentProps<
  T,
  TextOwnProps
>;

// Styled component
const StyledText = styled.p<{ kind: TextOwnProps["type"] }>`
  font-style: normal;
  font-size: var(--text-${({ kind }) => kind}-fontSize);
  line-height: var(--text-${({ kind }) => kind}-lineHeight);
  letter-spacing: var(--text-${({ kind }) => kind}-letterSpacing);
  color: var(--colors-text);
`;

export const Text = forwardRef(
  <T extends React.ElementType = "p">(
    { type, as, children, ...restProps }: TextProps<T>,
    ref: React.Ref<any>
  ) => {
    return (
      <StyledText as={as || "p"} ref={ref} kind={type} {...restProps}>
        {children}
      </StyledText>
    );
  }
);

Text.displayName = "Text";
